import React from "react";
import { Outlet } from "react-router-dom";

import { ContentLayout } from "#/components/ContentLayout";
import { withPaywall } from "#/components/WithPaywall";
import { UserPagePath } from "#/lib/pagesHelper";
import { canViewThesis } from "#/lib/permissions";

import { NavButton } from "../(components)/MainNav";

const PAGES = [
  {
    name: "Todas as Teses",
    path: UserPagePath.THESES,
  },
  {
    name: "Teses por Atividade Econômica",
    path: UserPagePath.THESES_PER_BUSINESS_ACTIVITY,
  },
  {
    name: "Teses do Momento",
    path: UserPagePath.TRENDING_THESES,
  },
  {
    name: "Últimas Teses Adicionadas",
    path: UserPagePath.LATEST_THESIS,
  },
  {
    name: "Minhas Teses",
    path: UserPagePath.PURCHASED_THESES,
  },
];

export function ThesesLibraryNavMenu() {
  return (
    <nav className="flex items-center space-x-4 lg:space-x-6 w-full">
      {PAGES.map((item, idx) => {
        return <NavButton item={item} key={idx} highlightExact />;
      })}
    </nav>
  );
}

export function ThesesLibrary() {
  return (
    <ContentLayout
      title="Biblioteca de Teses"
      description="Seu cardápio de oportunidades tributárias."
      navigation={<ThesesLibraryNavMenu />}
    >
      <Outlet />
    </ContentLayout>
  );
}

export default withPaywall(ThesesLibrary, canViewThesis);
